export const authHeader = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' };
  };
  
  export const fileAuthHeader = () => {
    const token = localStorage.getItem("accessToken");
    return { Authorization: `Bearer ${token}` };
  }